import React from 'react'

import Icon from '../Icon'

export default function CircledIcon({ theme, svg, ...props }) {
  if (svg) {
    return (
      <div {...props} className={theme.circled}>
        <Icon {...props} svg={svg} theme={theme} />
      </div>
    )
  }
  return null
}
